import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { DOCUMENT_TYPE_PREFIX_URL } from './constants/config.document-type'

const ListPage = lazy(() => import('./pages/ListPage.DocumentType'))

const DocumentTypeRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_TYPE_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default DocumentTypeRouters
